import {createFileRoute} from '@tanstack/react-router';
import {ExtensionPage} from '@/features/agent';

export const Route = createFileRoute('/_app/agents/extension')({
  component: () => <ExtensionPage />,
});
